import suremixLogo from '@/assets/brand/suremix-logo.webp';
import cppLogo from '@/assets/brand/cpp-logo.webp';
import suremixMark from '@/assets/brand/suremix-mark.webp';

/**
 * The platform's name and marks. The modules keep their own names
 * (Quarry, Concrete, Workshop, Management); this is the whole.
 * The logos were upscaled 4x (EDSR) from the supplied artwork.
 */
export const APP_NAME = 'Suremix Operations Platform';
export const APP_SHORT = 'Suremix Ops';

export const LOGOS = {
  suremix: suremixLogo,
  cpp: cppLogo,
  mark: suremixMark,
};
